import useTranslation from "next-translate/useTranslation";
import { SwiperSlide } from "swiper/react";
import OpportunityCard from "@/components/become-consultant/OpportunityCard";
import useIsMobile from "@/common/hook/useIsMobile";
import Slider from "@/components/common/Slider";

const YourOpportunities = ({ opportunities = [] }) => {
  const { t } = useTranslation("become-consultant");
  const isMobile = useIsMobile();

  return (
    <section className="container py-12 lg:py-32">
      <h2 className="text-xl lg:text-4xl font-semibold text-center">{t`your-opportunities.title`}</h2>
      <p className="mt-2 lg:mt-3 text-xs lg:text-base text-center text-grey-700">{t`your-opportunities.subtitle`}</p>
      {isMobile ? (
        <Slider slidesPerView={1.5}>
          {opportunities.map((opportunity) => (
            <SwiperSlide key={opportunity.id} className="py-4">
              <OpportunityCard opportunity={opportunity} />
            </SwiperSlide>
          ))}
        </Slider>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-16 mt-12">
          {opportunities.map((opportunity) => (
            <OpportunityCard key={opportunity.id} opportunity={opportunity} />
          ))}
        </div>
      )}
    </section>
  );
};

export default YourOpportunities;
